/* eslint-disable no-unused-vars */
import { React, useContext, useState, useEffect, useRef } from "react"
import SidebarDashboardSupervisor from "../Homepage/sidebars/SidebarDashboardSupervisor"

import { LoaderSmall } from "../../components/Loaders"

import _ from "lodash"
import axios from "axios"
import { UserContext } from "../../context/userContext"
import { GET_PARTICIPANTS_BY_STAFF } from "./queries"
import { useQuery } from "@apollo/client"

import styles from "../../styles/Dashboard.module.css"
import { callCloudFunction } from "../../helpers/cloudFunctionRequests"

export function useTimeout(callback, delay) {
  const timeoutRef = useRef(null)
  const savedCallback = useRef(callback)
  useEffect(() => {
    savedCallback.current = callback
  }, [callback])
  useEffect(() => {
    const tick = () => savedCallback.current()
    if (typeof delay === "number") {
      timeoutRef.current = window.setTimeout(tick, delay)
      return () => window.clearTimeout(timeoutRef.current)
    }
  }, [delay])
  return timeoutRef
}

export default function DashboardSupervisor() {
  const userCtx = useContext(UserContext)
  const [assigned_staff, setAssignedStaff] = useState(null)
  const [engaged, setKpiEngaged] = useState(null)
  const [unengaged, setKpiUnengaged] = useState(null)
  const [engagedLastSeven, setKpiEngagedLastSeven] = useState(null)
  const [engagedFourtin, setEngagedFourtin] = useState(null)

  const [notEngagedLastSixty, setKpiNotEngagedLastSixty] = useState(null)

  const [staffCaseloadCountsEngaged, setStaffCaseloadCountsEngaged] =
    useState(null)
  const [staffCaseloadCountsUnengaged, setStaffCaseloadCountsUnengaged] =
    useState(null)
  const [awaitingEngaged, setAwaitingEngaged] = useState(null)
  const [newLastSevenDays, setNewLastSevenDays] = useState(null)
  const [newLastThirtyDays, setNewLastThirtyDays] = useState(null)
  const [newLastSixtyDays, setNewLastSixtyDays] = useState(null)
  const [newLastNinetyDays, setNewLastNinetyDays] = useState(null)
  const [staffWithoutSupervisionSession, setStaffWithoutSupervisionSession] =
    useState(null)
  const [staffWithoutSupervisionPlan, setStaffWithoutSupervisionPlan] =
    useState(null)
  const [hasTimeElapsed, setHasTimeElapsed] = useState(false)
  const [loading, setLoading] = useState(true)

  // const [averageRSIScore, setKpiAverageRSIScore] = useState(null)
  // const [averageRSIScorePositive, setKpiAverageRSIScorePositive] =
  //   useState(null)
  // const [averageRecoveryCapital, setKpiAverageRecoveryCapital] = useState(null)
  // const [
  //   averageRecoveryCapitalPositives,
  //   setKpiAverageRecoveryCapitalPositives,
  // ] = useState(null)

  const { data, loading: loadingParticipants } = useQuery(
    GET_PARTICIPANTS_BY_STAFF,
    {
      variables: {
        staff_id: userCtx.session.user.staff_id,
        organization_id: userCtx.session.user.organization_id,
      },
    },
  )
  useEffect(() => {
    const fetchData = async () => {

      const engagedPostBody = {
        kpi: "CountActiveParticipants",
        args: {
          staff_id: userCtx.session.user.staff_id,
          engagement_type: "engaged",
          organization_id: userCtx.session.user.organization_id,
        },
      }

      const unengagedPostBody = {
        kpi: "CountActiveParticipants",
        args: {
          staff_id: userCtx.session.user.staff_id,
          engagement_type: "unengaged",
          organization_id: userCtx.session.user.organization_id,
        },
      }
      const notEngagedLastSixtyPostBody = {
        kpi: "CountEngagedParticipantsPerStaffInterval",
        args: {
          staff_id: userCtx.session.user.staff_id,
          engagement_type: "unengaged",
          interval: "60",
          organization_id: userCtx.session.user.organization_id,
        },
      }

      const assignedStaffPostBody = {
        kpi: "CountAssignedStaff",
        args: {
          uid: userCtx.session.user.staff_id,
          organization_id: userCtx.session.user.organization_id,
        },
      }

      const engagedLastSevenPostBody = {
        kpi: "CountEngagedParticipantsPerStaffInterval",
        args: {
          staff_id: userCtx.session.user.staff_id,
          engagement_type: "engaged",
          interval: "7",
          organization_id: userCtx.session.user.organization_id,
        },
      }
      const engagedLastFourtinPostBody = {
        kpi: "CountEngagedParticipantsPerStaffInterval",
        args: {
          staff_id: userCtx.session.user.staff_id,
          engagement_type: "engaged",
          interval: "14",
          organization_id: userCtx.session.user.organization_id,
        },
      }
      const staffCaseloadCountsEngagedPostBody = {
        kpi: "CountActiveParticipantsForAssignedStaff",
        args: {
          uid: userCtx.session.user.staff_id,
          engagement_type: "engaged",
          organization_id: userCtx.session.user.organization_id,
        },
      }

      const staffCaseloadCountsUnengagedPostBody = {
        kpi: "CountActiveParticipantsForAssignedStaff",
        args: {
          uid: userCtx.session.user.staff_id,
          engagement_type: "unengaged",
          organization_id: userCtx.session.user.organization_id,
        },
      }

      const awaitingEngagedPostBody = {
        kpi: "CountParticipantsAwaitingStaff",
        args: {
          organization_id: userCtx.session.user.organization_id,
        },
      }

      const newLastNinetyDaysPostBodyMultiple = {
        kpi: "CountNewIntakesFullIntervals",
        args: {
          organization_id: userCtx.session.user.organization_id,
        },
      }

      const staffWithoutSupervisionSessionPostBody = {
        kpi: "CountStaffNoSupervisionSessionInterval",
        args: {
          uid: userCtx.session.user.staff_id,
          interval: "7",
          organization_id: userCtx.session.user.organization_id,
        },
      }

      const staffWithoutSupervisionPlanPostBody = {
        kpi: "CountStaffNoSupervisionPlan",
        args: {
          uid: userCtx.session.user.staff_id,
          organization_id: userCtx.session.user.organization_id,
        },
      }

      // const averageRSIScorePostBody = {
      //   kpi: "AvgRsi",
      //   args: {
      //     staff_id: userCtx.session.user.staff_id,
      //     organization_id: userCtx.session.user.organization_id,
      //   },
      // }

      // const averageRSIScorePositivePostBody = {
      //   kpi: "AvgRsiPositiveIncrement",
      //   args: {
      //     staff_id: userCtx.session.user.staff_id,
      //     organization_id: userCtx.session.user.organization_id,
      //   },
      // }

      // const averageRecoveryCapitalPostBody = {
      //   kpi: "AvgRecoveryCapital",
      //   args: {
      //     staff_id: userCtx.session.user.staff_id,
      //     organization_id: userCtx.session.user.organization_id,
      //   },
      // }

      // const averageRecoveryCapitalPositivesPostBody = {
      //   kpi: "AvgRecoveryCapitalPositiveIncrement",
      //   args: {
      //     staff_id: userCtx.session.user.staff_id,
      //     organization_id: userCtx.session.user.organization_id,
      //   },
      // }

      const mainToken = userCtx.tokens.getMainToken()

      const kpiEngaged = callCloudFunction("getBiKpi", assignedStaffPostBody, mainToken)

      const kpiEngagedParticipant = callCloudFunction("getBiKpi", engagedPostBody, mainToken)


      const kpiUnengagedParticipant = callCloudFunction("getBiKpi", unengagedPostBody, mainToken)

      const kpiEngagedLastSevenParticipant = callCloudFunction("getBiKpi", engagedLastSevenPostBody, mainToken)

      const kpiEngagedLastFourtinParticipant = callCloudFunction("getBiKpi", engagedLastFourtinPostBody, mainToken)

      const kpiStaffCaseloadCountsEngaged = callCloudFunction("getBiKpi", staffCaseloadCountsEngagedPostBody, mainToken)

      const kpiStaffCaseloadCountsUnengaged = callCloudFunction("getBiKpi", staffCaseloadCountsUnengagedPostBody, mainToken)

      const kpiAwaitingEngaged = callCloudFunction("getBiKpi", awaitingEngagedPostBody, mainToken)

      const kpiNotEngagedLastSixty = callCloudFunction("getBiKpi", notEngagedLastSixtyPostBody, mainToken)

      const newLastNinetyDaysPostBodyMultiplePostBody = callCloudFunction("getBiKpi", newLastNinetyDaysPostBodyMultiple, mainToken)

      const kpiStaffWithoutSupervisionSessionPostBody = callCloudFunction("getBiKpi", staffWithoutSupervisionSessionPostBody, mainToken)

      const kpiStaffWithoutSupervisionPlan = callCloudFunction("getBiKpi", staffWithoutSupervisionPlanPostBody, mainToken)

      // const kpiAverageRSIScore = axios.post(
      //   `${endpoint}/getBiKpi`,
      //   averageRSIScorePostBody
      // )

      // const kpiAverageRSIScorePositive = axios.post(
      //   `${endpoint}/getBiKpi`,
      //   averageRSIScorePositivePostBody
      // )

      // const kpiAverageRecoveryCapital = axios.post(
      //   `${endpoint}/getBiKpi`,
      //   averageRecoveryCapitalPostBody
      // )

      // const kpiAverageRecoveryCapitalPositives = axios.post(
      //   `${endpoint}/getBiKpi`,
      //   averageRecoveryCapitalPositivesPostBody
      // )

      Promise.all([kpiEngaged])
        .then(function (values) {
          if (values[0]?.data?.msg === "Success") {
            if (!_.isNull(values[0]?.data.data)) {
              !_.isNull(values[0]?.data?.data[0]?.count_staff)
                ? setAssignedStaff(values[0]?.data?.data[0]?.count_staff)
                : setAssignedStaff("N/A")
            }
          }
        })
        .catch((err) => console.error(err))

      Promise.all([kpiEngagedParticipant])
        .then(function (values) {
          if (values[0]?.data?.msg === "Success") {
            if (!_.isNull(values[0]?.data.data)) {
              !_.isNull(values[0]?.data?.data[0]?.participant_count)
                ? setKpiEngaged(values[0]?.data?.data[0]?.participant_count)
                : setKpiEngaged("N/A")
            }
          }
        })
        .catch((err) => console.error(err))

      Promise.all([kpiUnengagedParticipant])
        .then(function (values) {
          if (values[0]?.data?.msg === "Success") {
            if (!_.isNull(values[0]?.data.data)) {
              !_.isNull(values[0]?.data?.data[0]?.participant_count)
                ? setKpiUnengaged(values[0]?.data?.data[0]?.participant_count)
                : setKpiUnengaged("N/A")
            }
          }
        })
        .catch((err) => console.error(err))

      Promise.all([kpiEngagedLastSevenParticipant])
        .then(function (values) {
          if (values[0]?.data?.msg === "Success") {
            if (!_.isNull(values[0]?.data.data)) {
              if (!_.isNull(values[0]?.data.data)) {
                !_.isNull(values[0]?.data?.data[0]?.count_participants)
                  ? setKpiEngagedLastSeven(
                      values[0]?.data?.data[0]?.count_participants,
                    )
                  : setKpiEngagedLastSeven("N/A")
              }
            }
          }
        })
        .catch((err) => console.error(err))

      Promise.all([kpiEngagedLastFourtinParticipant])
        .then(function (values) {
          if (values[0]?.data?.msg === "Success") {
            if (!_.isNull(values[0]?.data.data)) {
              if (!_.isNull(values[0]?.data.data)) {
                !_.isNull(values[0]?.data?.data[0]?.count_participants)
                  ? setEngagedFourtin(
                      values[0]?.data?.data[0]?.count_participants,
                    )
                  : setEngagedFourtin("N/A")
              }
            }
          }
        })
        .catch((err) => console.error(err))

      Promise.all([kpiNotEngagedLastSixty])
        .then(function (values) {
          if (values[0]?.data?.msg === "Success") {
            if (!_.isNull(values[0]?.data.data)) {
              !_.isNull(values[0]?.data?.data[0]?.count_participants)
                ? setKpiNotEngagedLastSixty(
                    values[0]?.data?.data[0]?.count_participants,
                  )
                : setKpiNotEngagedLastSixty("N/A")
            }
          }
        })
        .catch((err) => console.error(err))

      Promise.all([kpiStaffCaseloadCountsEngaged])
        .then(function (values) {
          if (values[0]?.data?.msg === "Success") {
            if (!_.isNull(values[0]?.data.data)) {
              !_.isNull(values[0]?.data?.data[0]?.participant_count)
                ? setStaffCaseloadCountsEngaged(
                    values[0]?.data?.data[0]?.participant_count,
                  )
                : setStaffCaseloadCountsEngaged("N/A")
            }
          }
        })
        .catch((err) => console.error(err))

      Promise.all([kpiStaffCaseloadCountsUnengaged])
        .then(function (values) {
          if (values[0]?.data?.msg === "Success") {
            if (!_.isNull(values[0]?.data.data)) {
              !_.isNull(values[0]?.data?.data[0]?.participant_count)
                ? setStaffCaseloadCountsUnengaged(
                    values[0]?.data?.data[0]?.participant_count,
                  )
                : setStaffCaseloadCountsUnengaged("N/A")
            }
          }
        })
        .catch((err) => console.error(err))

      Promise.all([kpiAwaitingEngaged])
        .then(function (values) {
          if (values[0]?.data?.msg === "Success") {
            if (!_.isNull(values[0]?.data.data)) {
              !_.isNull(values[0]?.data?.data[0]?.count_participants)
                ? setAwaitingEngaged(
                    values[0]?.data?.data[0]?.count_participants,
                  )
                : setAwaitingEngaged("N/A")
            } else {
              setAwaitingEngaged("N/A")
            }
          }
        })
        .catch((err) => console.error(err))

      Promise.all([newLastNinetyDaysPostBodyMultiplePostBody])
        .then(function (values) {
          if (values[0]?.data?.msg === "Success") {
            !_.isNull(values[0]?.data?.data)
              ? setNewLastSevenDays(values[0]?.data?.data?.last7DaysCount)
              : setNewLastSevenDays("N/A")

            !_.isNull(values[0]?.data?.data)
              ? setNewLastThirtyDays(values[0]?.data?.data?.last30DaysCount)
              : setNewLastThirtyDays("N/A")

            !_.isNull(values[0]?.data?.data)
              ? setNewLastSixtyDays(values[0]?.data?.data?.last60DaysCount)
              : setNewLastSixtyDays("N/A")

            !_.isNull(values[0]?.data?.data)
              ? setNewLastNinetyDays(values[0]?.data?.data?.last90DaysCount)
              : setNewLastNinetyDays("N/A")
          }
        })
        .catch((err) => console.error(err))

      Promise.all([kpiStaffWithoutSupervisionSessionPostBody])
        .then(function (values) {
          if (values[0]?.data?.msg === "Success") {
            if (!_.isNull(values[0]?.data.data)) {
              !_.isNull(values[0]?.data?.data[0]?.count_staff)
                ? setStaffWithoutSupervisionSession(
                    values[0]?.data?.data[0]?.count_staff,
                  )
                : setStaffWithoutSupervisionSession("N/A")
            }
          }
        })
        .catch((err) => console.error(err))

      Promise.all([kpiStaffWithoutSupervisionPlan])
        .then(function (values) {
          if (values[0]?.data?.msg === "Success") {
            if (!_.isNull(values[0]?.data.data)) {
              !_.isNull(values[0]?.data?.data[0]?.count_staff)
                ? setStaffWithoutSupervisionPlan(
                    values[0]?.data?.data[0]?.count_staff,
                  )
                : setStaffWithoutSupervisionPlan("N/A")
            }
          }
        })
        .catch((err) => console.error(err))

      // Promise.all([kpiAverageRSIScorePositive])
      //   .then(function (values) {
      //     if (values[0]?.data?.msg === "Success") {
      //       if (!_.isNull(values[0]?.data.data)) {
      //         !_.isNull(values[0]?.data?.data[0]?.sum_rsi_positive_increase)
      //           ? setKpiAverageRSIScorePositive(
      //               values[0]?.data?.data[0]?.sum_rsi_positive_increase
      //             )
      //           : setKpiAverageRSIScorePositive("N/A")
      //       }
      //     }
      //   })
      //   .catch((err) => console.error(err))

      // Promise.all([kpiAverageRSIScore])
      //   .then(function (values) {
      //     if (values[0]?.data?.msg === "Success") {
      //       if (!_.isNull(values[0]?.data.data)) {
      //         !_.isNull(values[0]?.data?.data[0]?.avg_rsi_scaled)
      //           ? setKpiAverageRSIScore(
      //               values[0]?.data?.data[0]?.avg_rsi_scaled
      //             )
      //           : setKpiAverageRSIScore("N/A")
      //       }
      //     }
      //   })
      //   .catch((err) => console.error(err))

      // Promise.all([kpiAverageRecoveryCapital])
      //   .then(function (values) {
      //     if (values[0]?.data?.msg === "Success") {
      //       if (!_.isNull(values[0]?.data.data)) {
      //         !_.isNull(values[0]?.data?.data[0]?.avg_assessment_score)
      //           ? setKpiAverageRecoveryCapital(
      //               values[0]?.data?.data[0]?.avg_assessment_score
      //             )
      //           : setKpiAverageRecoveryCapital("N/A")
      //       }
      //     }
      //   })
      //   .catch((err) => console.error(err))

      // Promise.all([kpiAverageRecoveryCapitalPositives])
      //   .then(function (values) {
      //     if (values[0]?.data?.msg === "Success") {
      //       if (!_.isNull(values[0]?.data.data)) {
      //         !_.isNull(
      //           values[0]?.data?.data[0]?.sum_assessment_positive_increase
      //         )
      //           ? setKpiAverageRecoveryCapitalPositives(
      //               values[0]?.data?.data[0]?.sum_assessment_positive_increase
      //             )
      //           : setKpiAverageRecoveryCapitalPositives("N/A")
      //       }
      //     }
      //   })
      //   .catch((err) => console.error(err))

      setLoading(false)
    }

    fetchData()
  }, [userCtx.session.user.organization_id, userCtx.session.user.staff_id])

  useTimeout(() => {
    setHasTimeElapsed(true)
  }, 5000)
  if (loadingParticipants) return null
  if (loading) return null
  return (
    <div className="layout-with-sidebar">
      <SidebarDashboardSupervisor />

      <div className="my-dashboard-wrapper">
        <div className="grids-container">
          <h1>{userCtx.session.user.organization_name} </h1>
          <div className={`grid-data  ${styles["custom-supervision-layout"]}`}>
            <div className="title-first-column">
              <h2>Awaiting Staff Assignment</h2>
            </div>
            <div className="title-middle-column">
              <h2>Participant Intakes</h2>
            </div>
            <div className="title-last-column"></div>
            <div className="box-data-engagement purple">
              <div className="text-wrapper">
                <h3></h3>
                <h1 style={{ marginTop: "10px" }}>
                  {!_.isNil(awaitingEngaged) || hasTimeElapsed ? (
                    !_.isNil(awaitingEngaged) ? (
                      awaitingEngaged
                    ) : (
                      "N/A"
                    )
                  ) : (
                    <LoaderSmall />
                  )}
                </h1>
              </div>

              <div className="img-wrapper">
                <svg
                  width="51"
                  height="56"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7.35 1.75C3.85 5.18 6.3 11.2 11.2 11.2c2.87 0 5.6-2.73 5.6-5.6 0-2.87-2.73-5.6-5.6-5.6-1.33 0-2.8.63-3.85 1.75ZM1.75 15.75C.07 17.43 0 17.71 0 28.35 0 38.71.07 39.2 1.4 39.2c1.33 0 1.4.49 1.4 8.4V56h5.6V39.2H14V56h5.6V25.2H14v8.4H5.6v-14h25.2V14H17.15C3.5 14 3.43 14 1.75 15.75ZM36.4 16.8v2.8h14V14h-14v2.8Z"
                    fill="#ccced0"
                  ></path>
                  <path
                    d="M25.2 28v2.8h5.6v-5.6h-5.6V28ZM36.4 28v2.8h14v-5.6h-14V28ZM25.2 39.2V42h5.6v-5.6h-5.6v2.8ZM36.4 39.2V42h14v-5.6h-14v2.8ZM25.2 50.4v2.8h5.6v-5.6h-5.6v2.8ZM36.4 50.4v2.8h14v-5.6h-14v2.8Z"
                    fill="#ccced0"
                  ></path>
                </svg>
              </div>
            </div>
            <div className="box-two-elements box-two-columns">
              <div className="multiple-box-wrapper">
                <div className="metric-wrapper">
                  <h1>
                    {!_.isNil(newLastSevenDays) || hasTimeElapsed ? (
                      !_.isNil(newLastSevenDays) ? (
                        newLastSevenDays
                      ) : (
                        "N/A"
                      )
                    ) : (
                      <LoaderSmall />
                    )}
                  </h1>
                  <h3>last 7 Days</h3>
                </div>
                <div className="metric-wrapper">
                  <h1>
                    {!_.isNil(newLastThirtyDays) || hasTimeElapsed ? (
                      !_.isNil(newLastThirtyDays) ? (
                        newLastThirtyDays
                      ) : (
                        "N/A"
                      )
                    ) : (
                      <LoaderSmall />
                    )}
                  </h1>
                  <h3>last 30 Days</h3>
                </div>
                <div className="metric-wrapper">
                  <h1>
                    {!_.isNil(newLastSixtyDays) || hasTimeElapsed ? (
                      !_.isNil(newLastSixtyDays) ? (
                        newLastSixtyDays
                      ) : (
                        "N/A"
                      )
                    ) : (
                      <LoaderSmall />
                    )}
                  </h1>
                  <h3>last 60 Days</h3>
                </div>
                <div className="metric-wrapper">
                  <h1>
                    {!_.isNil(newLastNinetyDays) || hasTimeElapsed ? (
                      !_.isNil(newLastNinetyDays) ? (
                        newLastNinetyDays
                      ) : (
                        "N/A"
                      )
                    ) : (
                      <LoaderSmall />
                    )}
                  </h1>
                  <h3>last 90 Days</h3>
                </div>
              </div>
            </div>
          </div>

          <div className={styles["divider-line"]}></div>

          <div
            className={`${styles["two-columns"]} ${
              ![1, 2, 3, 4, 9, 10].includes(userCtx.session.user.staff_role)
                ? styles["center-content"]
                : ""
            }`}
          >
            {/* My Participants Section */}
            <div>
              <div className="title-first-column">
                <h2>My Participants</h2>
              </div>
              {data?.participantsByStaff.length > 0 ? (
                <>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "1rem",
                    }}
                  >
                    <div className="box-two-elements purple">
                      <div className={styles["box-wrapper-two-elements"]}>
                        <h3 className={styles["title"]}>
                          Engaged Participants
                        </h3>
                        <div className="two-box-wrapper">
                          <div className={`${styles["metric-wrapper"]} purple`}>
                            <h1>
                              {!_.isNil(engagedLastSeven) || hasTimeElapsed ? (
                                !_.isNil(engagedLastSeven) ? (
                                  engagedLastSeven
                                ) : (
                                  "N/A"
                                )
                              ) : (
                                <LoaderSmall />
                              )}
                            </h1>
                            <p>Last 7 days</p>
                          </div>
                          <div
                            className={`${styles["metric-wrapper-two"]} purple`}
                          >
                            <h1>
                              {!_.isNil(engagedFourtin) || hasTimeElapsed ? (
                                !_.isNil(engagedFourtin) ? (
                                  engagedFourtin
                                ) : (
                                  "N/A"
                                )
                              ) : (
                                <LoaderSmall />
                              )}
                            </h1>
                            <p>Last 14 days</p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="box-data-engagement-days">
                      <div className="text-right-end">
                        <h3>Unengaged Participants</h3>
                        <h1>
                          {!_.isNil(unengaged) || hasTimeElapsed ? (
                            !_.isNil(unengaged) ? (
                              unengaged
                            ) : (
                              "N/A"
                            )
                          ) : (
                            <LoaderSmall />
                          )}
                        </h1>
                      </div>
                      {/* <div className="image-plus-days-wrapper">
                        <div className="img-wrapper with-days">
                          <svg
                            width="58"
                            height="56"
                            viewBox="0 0 58 56"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <circle
                              cx="24"
                              cy="12"
                              r="12"
                              fill="#ccced0"
                            ></circle>
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M41.6598 34.2801C29.1135 25.9392 12.0186 27.41 1.09556 38.5758L0 39.6957V47H37.5268L37.8733 45.9336C38.0072 45.5216 37.8605 45.0702 37.5101 44.8156L29.4198 38.9377C28.6361 38.3683 29.0389 37.1287 30.0076 37.1287H40.0077C40.4409 37.1287 40.8249 36.8497 40.9587 36.4377L41.6598 34.2801Z"
                              fill="#ccced0"
                            ></path>
                            <path
                              d="M44.0489 32.9271C44.3483 32.0057 45.6517 32.0057 45.9511 32.9271L47.6942 38.2918C47.828 38.7038 48.212 38.9828 48.6452 38.9828H54.2861C55.2548 38.9828 55.6576 40.2224 54.8738 40.7918L50.3103 44.1074C49.9598 44.362 49.8132 44.8134 49.947 45.2254L51.6902 50.5902C51.9895 51.5115 50.935 52.2776 50.1513 51.7082L45.5878 48.3926C45.2373 48.138 44.7627 48.138 44.4122 48.3926L39.8487 51.7082C39.065 52.2776 38.0105 51.5115 38.3098 50.5902L40.053 45.2254C40.1868 44.8134 40.0402 44.362 39.6897 44.1074L35.1262 40.7918C34.3425 40.2224 34.7452 38.9828 35.7139 38.9828H41.3548C41.788 38.9828 42.172 38.7038 42.3058 38.2918L44.0489 32.9271Z"
                              fill="#ccced0"
                            ></path>
                          </svg>
                        </div>
                        <h4>last 30 days</h4>
                      </div> */}
                    </div>

                    {/* <div className="box-two-elements">
                      <h3>Average Recovery Capital</h3>
                      <div className="two-box-wrapper">
                        <div className="metric-wrapper">
                          <h1>
                            {!_.isNil(averageRecoveryCapital) ||
                            hasTimeElapsed ? (
                              !_.isNil(averageRecoveryCapital) ? (
                                averageRecoveryCapital
                              ) : (
                                "N/A"
                              )
                            ) : (
                              <LoaderSmall />
                            )}
                          </h1>
                        </div>
                        <div className="metric-wrapper">
                          <h1>
                            {!_.isNil(averageRecoveryCapitalPositives) ||
                            hasTimeElapsed ? (
                              !_.isNil(averageRecoveryCapitalPositives) ? (
                                averageRecoveryCapitalPositives
                              ) : (
                                "N/A"
                              )
                            ) : (
                              <LoaderSmall />
                            )}
                          </h1>
                          <h3>Positive increases</h3>
                        </div>
                      </div>
                    </div> */}
                  </div>
                </>
              ) : (
                <p style={{ textAlign: "center" }}>No assigned participants</p>
              )}
            </div>
            {/* My Staffs Section */}
            {[1, 2, 3, 4, 9, 10].includes(userCtx.session.user.staff_role) && (
              <div>
                <div className="title-middle-column">
                  <h2>My Staff</h2>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "1.5rem",
                  }}
                >
                  <div className="box-data-engagement-days">
                    <div className="text-right-end">
                      <h3>Number of assigned staff</h3>
                      <h1>
                        {!_.isNil(assigned_staff) || hasTimeElapsed ? (
                          !_.isNil(assigned_staff) ? (
                            assigned_staff
                          ) : (
                            "N/A"
                          )
                        ) : (
                          <LoaderSmall />
                        )}
                      </h1>
                    </div>
                    <div className="image-plus-days-wrapper">
                      <div className="img-wrapper with-days">
                        <svg
                          width="48"
                          height="47"
                          viewBox="0 0 48 47"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M0 39.6957L1.09556 38.5758C13.4563 25.9403 33.7205 25.72 46.3531 38.0838L48 39.6957V47H0V39.6957Z"
                            fill="#ccced0"
                          ></path>
                          <circle
                            cx="24"
                            cy="12"
                            r="12"
                            fill="#ccced0"
                          ></circle>
                        </svg>
                      </div>
                    </div>
                  </div>
                  <div className="box-data-engagement-days">
                    <div className="text-right-end">
                      <h3>Staff without a Supervision session last 7 days</h3>
                      <h1>
                        {!_.isNil(staffWithoutSupervisionSession) ||
                        hasTimeElapsed ? (
                          !_.isNil(staffWithoutSupervisionSession) ? (
                            staffWithoutSupervisionSession
                          ) : (
                            "N/A"
                          )
                        ) : (
                          <LoaderSmall />
                        )}
                      </h1>
                    </div>
                    <div className="image-plus-days-wrapper">
                      <div className="img-wrapper with-days">
                        <svg
                          width="48"
                          height="47"
                          viewBox="0 0 48 47"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M0 39.6957L1.09556 38.5758C13.4563 25.9403 33.7205 25.72 46.3531 38.0838L48 39.6957V47H0V39.6957Z"
                            fill="#ccced0"
                          ></path>
                          <circle
                            cx="24"
                            cy="12"
                            r="12"
                            fill="#ccced0"
                          ></circle>
                        </svg>
                      </div>
                    </div>
                  </div>
                  <div className="box-data-engagement-days">
                    <div className="text-right-end">
                      <h3>Staff without a Supervision Plan</h3>
                      <h1>
                        {!_.isNil(staffWithoutSupervisionPlan) ||
                        hasTimeElapsed ? (
                          !_.isNil(staffWithoutSupervisionPlan) ? (
                            staffWithoutSupervisionPlan
                          ) : (
                            "N/A"
                          )
                        ) : (
                          <LoaderSmall />
                        )}
                      </h1>
                    </div>
                    <div className="image-plus-days-wrapper">
                      <div className="img-wrapper with-days">
                        <svg
                          width="48"
                          height="47"
                          viewBox="0 0 48 47"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M0 39.6957L1.09556 38.5758C13.4563 25.9403 33.7205 25.72 46.3531 38.0838L48 39.6957V47H0V39.6957Z"
                            fill="#ccced0"
                          ></path>
                          <circle
                            cx="24"
                            cy="12"
                            r="12"
                            fill="#ccced0"
                          ></circle>
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
